export * from './info-ribbon.module'
export * from './info-ribbon/info-ribbon.component'